import React from 'react';
import { HyperdbListing } from '../../../../hyperdb';
import { displayLocalDate } from '../../../../helpers/date';

export default HyperdbListing({
  collectionName: 'inquiries',
  namespace: 'inquiry',
  mountedUrl: '/daily-rental/inquiries',
  title: 'Inquiries',
  columns: [
    { attribute: 'reference' },
    { attribute: 'creation_date', label: 'date', value: (o) => displayLocalDate(o.creation_date) },
    { attribute: 'processed', value: (o) => o.processed ? <i className="fas fa-check" /> : null },
    { attribute: 'property.name', label: 'property' },
    { attribute: 'customer.name', label: 'customer' },
    { attribute: 'arrival_date', label: 'arrival' },
    { attribute: 'departure_date', label: 'departure' },
    { attribute: 'origin' },
  ],
  useQuickSearch: true,
  filters: [
    // { value: 'new' },
    { value: 'pending' },
    // { value: 'processing' },
    { value: 'processed' },
    // { value: 'aborted' },
  ],
  defaultSort: ['creation_date', 'desc'],
  advancedFilters: {
    creation_date: { type: 'date', label: 'date' },
    arrival_date: { type: 'date', label: 'arrival' },
    departure_date: { type: 'date', label: 'departure' },
  },
  onEdit: (object, props) => props.api.routing.redirect(props.router, `/daily-rental/inquiries/${object.id}/edit`),
  canShow: true,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/inquiry/containers/Listing.jsx